var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"nav",attrs:{"app":"","fixed":"","color":"white"}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.toggleSideMenu()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }